export const removeHyphensAndSlashes = (inputString: string) => {
  // Replace all "-" and "/" with an empty string
  return inputString.replace(/[-/]/g, '');
};
